'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupingName$$anon$39(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$GroupingName$$anon$39 as $c_Lpresto_types$GroupingName$$anon$39 };
$p = $c_Lpresto_types$GroupingName$$anon$39.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupingName$$anon$39;
/** @constructor */
function $h_Lpresto_types$GroupingName$$anon$39() {
}
export { $h_Lpresto_types$GroupingName$$anon$39 as $h_Lpresto_types$GroupingName$$anon$39 };
$h_Lpresto_types$GroupingName$$anon$39.prototype = $p;
$p.cA = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lteq__O__O__Z(this, x, y);
});
$p.cy = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__gteq__O__O__Z(this, x, y);
});
$p.cq = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__lt__O__O__Z(this, x, y);
});
$p.cr = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__max__O__O__O(this, x, y);
});
$p.cI = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__min__O__O__O(this, x, y);
});
$p.cz = (function(other) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_s_math_Ordering__isReverseOf__s_math_Ordering__Z(this, other);
});
$p.b4 = (function(x, y) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__compareTo__T__I(x, y);
});
var $d_Lpresto_types$GroupingName$$anon$39 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupingName$$anon$39, "presto.types$GroupingName$$anon$39", ({
  a0o: 1,
  O: 1,
  a: 1,
  Q: 1,
  U: 1,
  W: 1
}));
export { $d_Lpresto_types$GroupingName$$anon$39 as $d_Lpresto_types$GroupingName$$anon$39 };
//# sourceMappingURL=presto.types$-Grouping-Name$$anon$39.js.map
